var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimaldog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 95,
    viewBox: "0 0 100 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1:211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1204 37.497C82.7079 37.4342 84.2964 36.9318 85.6946 35.9528L90.7963 32.3806C94.6783 29.6624 95.6219 24.3119 92.9036 20.4299L81.1603 3.65933C79.5623 1.37702 77.0542 0.111808 74.4697 0.00808716C72.8759 0.0677152 71.2804 0.569413 69.8767 1.55225L63.268 6.1797C70.2843 8.90043 75.2613 15.711 75.2613 23.6882V34.8795C76.8333 36.5141 78.9507 37.4143 81.1204 37.497V37.497Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6239 40.8518H62.306C67.1262 40.8518 71.5928 42.3635 75.2599 44.9376V23.6881C75.2599 13.3176 66.853 4.91074 56.4825 4.91074H42.5864C32.216 4.91074 23.8091 13.3176 23.8091 23.6881V44.841C27.4496 42.3263 31.8644 40.8518 36.6239 40.8518V40.8518Z",
    fill: "#E19974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.307 86.0029H36.625C24.1572 86.0029 14.0499 75.8956 14.0499 63.4278C14.0499 50.9601 24.1572 40.8528 36.625 40.8528H62.307C74.7748 40.8528 84.8821 50.9601 84.8821 63.4278C84.8821 75.8956 74.775 86.0029 62.307 86.0029V86.0029Z",
    fill: "#ECBBA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.874 36.4811C34.8962 36.4811 34.1036 35.6886 34.1036 34.7108V29.0459C34.1036 28.0681 34.8962 27.2756 35.874 27.2756C36.8518 27.2756 37.6443 28.0681 37.6443 29.0459V34.7108C37.6443 35.6886 36.8518 36.4811 35.874 36.4811Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.883 36.4816C61.9052 36.4816 61.1127 35.689 61.1127 34.7112V29.0463C61.1127 28.0685 61.9052 27.276 62.883 27.276C63.8608 27.276 64.6533 28.0685 64.6533 29.0463V34.7112C64.6533 35.689 63.8608 36.4816 62.883 36.4816Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8104 23.6885C23.8104 15.6988 28.8029 8.87901 35.8365 6.16696L29.2463 1.55253C25.3643 -1.16568 20.0138 -0.222144 17.2956 3.65985L5.55253 20.4304C2.83432 24.3124 3.77786 29.6629 7.65985 32.3811L12.7616 35.9536C16.2511 38.3969 20.9261 37.8799 23.8104 34.9312V23.6885Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4843 4.91074H48.4551C58.8255 4.91074 67.2324 13.3176 67.2324 23.6881V41.3951C70.1638 42.0478 72.8818 43.2671 75.2616 44.9376V23.6881C75.2616 13.3178 66.8548 4.91074 56.4843 4.91074V4.91074Z",
    fill: "#DC8758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5696 20.4309L81.8267 3.66031C79.3148 0.0728073 74.5558 -1.00255 70.7841 0.999669C71.9488 1.61514 72.9899 2.50705 73.7975 3.66031L85.5406 20.4311C88.2588 24.3131 87.3155 29.6636 83.4333 32.3818L78.3315 35.954C78.0368 36.1606 77.7327 36.344 77.4229 36.5085C80.1784 37.9652 83.632 37.8646 86.3607 35.954L91.4625 32.3818C95.3445 29.6634 96.288 24.3129 93.5696 20.4309V20.4309Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3079 40.8528H54.5242C66.992 40.8528 77.0993 50.9598 77.0993 63.4278V63.428C77.0993 75.8958 66.9922 86.0031 54.5242 86.0031H62.3079C74.7756 86.0031 84.8829 75.896 84.8829 63.428V63.4278C84.8829 50.9601 74.7758 40.8528 62.3079 40.8528V40.8528Z",
    fill: "#E8AD8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5315 46.6381C30.5306 46.6381 26.4768 50.6921 26.4768 55.6929C26.4768 62.016 31.6025 67.1419 37.9258 67.1419H43.0968C46.5641 67.1419 49.3748 64.3312 49.3748 60.8639C49.3748 59.2407 49.3748 48.1396 49.3748 46.6381C35.4443 46.6381 49.6447 46.6381 35.5315 46.6381V46.6381Z",
    fill: "#F4D7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2191 46.6381C68.2201 46.6381 72.2739 50.6921 72.2739 55.6929C72.2739 62.016 67.1482 67.1419 60.8249 67.1419H55.6539C52.1866 67.1419 49.3758 64.3312 49.3758 60.8639C49.3758 59.2407 49.3758 48.1396 49.3758 46.6381H63.2191Z",
    fill: "#F4D7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5033 51.8531C52.3963 51.8531 54.8854 49.1758 55.9934 45.3343C56.6397 43.0933 54.9735 40.8528 52.6412 40.8528H46.3654C44.0331 40.8528 42.3667 43.0933 43.0132 45.3343C44.1212 49.1758 46.6103 51.8531 49.5033 51.8531V51.8531Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1645 4.99612C24.6163 5.88049 17.1399 13.9102 17.1399 23.6892V37.4877C19.5794 37.6398 22.0351 36.7479 23.8114 34.9317V23.6889C23.8114 15.6992 28.8039 8.87949 35.8375 6.16721L34.1645 4.99612Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1:211",
    x: 0,
    y: 0,
    width: 99.1223,
    height: 94.0031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1:211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1:211",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimaldog);
export default __webpack_public_path__ + "static/media/animaldog.e92f51556e0cd213ae8a9f1cc1e08d15.svg";
export { ForwardRef as ReactComponent };